import * as React from 'react';
import { styled, ThemeProvider } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { Text, TextTag, TokenTextAppearance, TokenTextColor } from '../text';
import { AirConditioning, StarOutline, Offers, Bookmark, Alert, CheckmarkCircle, } from '@volkswagen-onehub/icons-core';
export const getBackgroundColorByAppearance = (props) => {
    const { theme, appearance } = props;
    const tokensColorsObj = Object.assign(Object.assign({}, theme.colors.signal), { new: theme.colors.signal.promo, alert: theme.colors.signal.neutral });
    return tokensColorsObj[appearance];
};
const getColorByAppearance = (props) => {
    const { theme, appearance } = props;
    if (['success', 'alert', 'error', 'bookmark'].includes(appearance)) {
        return theme.colors.content.inverted;
    }
    return theme.colors.content.tertiary;
};
const getIconByAppearance = (appearance, iconVariant = 'small') => {
    switch (appearance) {
        case 'new':
            return React.createElement(StarOutline, { variant: iconVariant, ariaHidden: true });
        case 'offer':
            return React.createElement(Offers, { variant: iconVariant, ariaHidden: true });
        case 'bookmark':
            return React.createElement(Bookmark, { variant: iconVariant, ariaHidden: true });
        case 'success':
            return React.createElement(CheckmarkCircle, { variant: iconVariant, ariaHidden: true });
        case 'error':
        case 'alert':
            return React.createElement(Alert, { variant: iconVariant, ariaHidden: true });
        default:
            return React.createElement(AirConditioning, { variant: iconVariant, ariaHidden: true }); //icon for 'info
    }
};
const StyledDisplayTag = styled.div.withConfig({ displayName: "StyledDisplayTag", componentId: "sc-1xqza3j" }) `display:flex;gap:${({ theme }) => theme.size.static100};align-items:center;width:fit-content;height:${({ theme }) => theme.size.static350};background-color:${getBackgroundColorByAppearance};color:${getColorByAppearance};padding:${({ theme }) => theme.size.static150};p{margin-top:${({ theme }) => theme.size.static0};::first-letter{text-transform:uppercase;}}`;
export const DisplayTag = (props) => {
    //className is added to the props to be able to overwrite the StyledDisplayTag className
    const { appearance, id, text, hideIcon = false, className, iconVariant, } = props;
    const commonProps = getCommonProps(props);
    return (React.createElement(ThemeProvider, { theme: "main" },
        React.createElement(StyledDisplayTag, Object.assign({ appearance: appearance, className: className, id: id }, commonProps),
            !hideIcon && getIconByAppearance(appearance, iconVariant),
            React.createElement(Text, { tag: TextTag.p, appearance: TokenTextAppearance.copy100, color: TokenTextColor.inherit }, text))));
};
//this export is needed to expose the getIconByAppearance function for testing
//for some reason, if the `export` keyword is added before the function declaration instead
// the table properties will disappear from the storybook page
export { getIconByAppearance };
DisplayTag.displayName = 'DisplayTag';
